var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/urls.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["queryParams"], 
["core", "absoluteURL"], 
function (l_queryParams, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("queryParams", l_queryParams);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_2 = "";t_2 += runtime.suppressValue((lineno = 1, colno = 73, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "genericUrl"), "genericUrl", context, ["/",l_queryParams,runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL")])), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("homepageUrl");
context.setVariable("homepageUrl", macro_t_1);
var macro_t_3 = runtime.makeMacro(
["slug", "queryParams"], 
["core", "absoluteURL", "excludeContextPath"], 
function (l_slug, l_queryParams, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slug", l_slug);
frame.set("queryParams", l_queryParams);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_4 = "";t_4 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, ((lineno = 5, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + l_slug)), env.opts.autoescape);
if(l_queryParams) {
t_4 += "?";
t_4 += runtime.suppressValue(l_queryParams, env.opts.autoescape);
;
}
else {
if((lineno = 8, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.webview"]))) {
t_4 += "?webview=true";
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_4);
});
context.addExport("genericUrl");
context.setVariable("genericUrl", macro_t_3);
var macro_t_5 = runtime.makeMacro(
["slug", "queryParams"], 
["core"], 
function (l_slug, l_queryParams, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slug", l_slug);
frame.set("queryParams", l_queryParams);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_6 = "";t_6 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, ((lineno = 14, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "False"),runtime.contextOrFrameLookup(context, frame, "True"),runtime.contextOrFrameLookup(context, frame, "True"),runtime.contextOrFrameLookup(context, frame, "False")])) + "" + l_slug)), env.opts.autoescape);
if(l_queryParams) {
t_6 += "?";
t_6 += runtime.suppressValue(l_queryParams, env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_6);
});
context.addExport("staticUrl");
context.setVariable("staticUrl", macro_t_5);
var macro_t_7 = runtime.makeMacro(
["slug", "queryParams"], 
["core"], 
function (l_slug, l_queryParams, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slug", l_slug);
frame.set("queryParams", l_queryParams);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_8 = "";t_8 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, ((lineno = 16, colno = 62, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "False"),runtime.contextOrFrameLookup(context, frame, "True"),runtime.contextOrFrameLookup(context, frame, "False"),runtime.contextOrFrameLookup(context, frame, "True")])) + "" + l_slug)), env.opts.autoescape);
if(l_queryParams) {
t_8 += "?";
t_8 += runtime.suppressValue(l_queryParams, env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_8);
});
context.addExport("staticLibUrl");
context.setVariable("staticLibUrl", macro_t_7);
var macro_t_9 = runtime.makeMacro(
["slug", "queryParams"], 
["core", "absoluteURL", "excludeContextPath"], 
function (l_slug, l_queryParams, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slug", l_slug);
frame.set("queryParams", l_queryParams);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_10 = "";t_10 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, ((lineno = 28, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "" + "" + l_slug)), env.opts.autoescape);
if(l_queryParams) {
t_10 += "?";
t_10 += runtime.suppressValue(l_queryParams, env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_10);
});
context.addExport("categoryUrl");
context.setVariable("categoryUrl", macro_t_9);
var macro_t_11 = runtime.makeMacro(
["slug", "queryParams"], 
["core", "absoluteURL", "excludeContextPath"], 
function (l_slug, l_queryParams, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slug", l_slug);
frame.set("queryParams", l_queryParams);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_12 = "";t_12 += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("sanitize_url").call(context, ((lineno = 41, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "shop/" + "" + l_slug))), env.opts.autoescape);
if(l_queryParams) {
t_12 += "?";
t_12 += runtime.suppressValue(env.getFilter("safe").call(context, l_queryParams), env.opts.autoescape);
;
}
else {
if((lineno = 44, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["category.categorySlug"]))) {
t_12 += "?category=";
t_12 += runtime.suppressValue((lineno = 45, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["category.categorySlug"])), env.opts.autoescape);
t_12 += "\n    ";
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_12);
});
context.addExport("productUrl");
context.setVariable("productUrl", macro_t_11);
var macro_t_13 = runtime.makeMacro(
["slug", "queryParams"], 
["core", "absoluteURL", "excludeContextPath"], 
function (l_slug, l_queryParams, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slug", l_slug);
frame.set("queryParams", l_queryParams);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_14 = "";t_14 += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("sanitize_url").call(context, ((lineno = 57, colno = 110, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "shop/style/" + "" + l_slug))), env.opts.autoescape);
if(l_queryParams) {
t_14 += "?";
t_14 += runtime.suppressValue(env.getFilter("safe").call(context, l_queryParams), env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_14);
});
context.addExport("productStyleUrl");
context.setVariable("productStyleUrl", macro_t_13);
var macro_t_15 = runtime.makeMacro(
["slug", "queryParams"], 
["core", "absoluteURL", "excludeContextPath"], 
function (l_slug, l_queryParams, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slug", l_slug);
frame.set("queryParams", l_queryParams);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_16 = "";var t_17;
t_17 = env.getFilter("sanitize_url").call(context, ((lineno = 67, colno = 119, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "shop/" + "" + l_slug));
frame.set("qsUrl", t_17, true);
if(frame.topLevel) {
context.setVariable("qsUrl", t_17);
}
if(frame.topLevel) {
context.addExport("qsUrl", t_17);
}
t_16 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "qsUrl"), env.opts.autoescape);
if(l_queryParams) {
t_16 += runtime.suppressValue(((runtime.inOperator("?",runtime.contextOrFrameLookup(context, frame, "qsUrl"))?"&":"?")) + "" + env.getFilter("safe").call(context, l_queryParams), env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_16);
});
context.addExport("quickshopUrl");
context.setVariable("quickshopUrl", macro_t_15);
var macro_t_18 = runtime.makeMacro(
["slug"], 
["core", "absoluteURL", "excludeContextPath"], 
function (l_slug, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slug", l_slug);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_19 = "";t_19 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, ((lineno = 77, colno = 92, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "account/" + "" + l_slug)), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_19);
});
context.addExport("accountUrl");
context.setVariable("accountUrl", macro_t_18);
var macro_t_20 = runtime.makeMacro(
[], 
["core", "absoluteURL", "excludeContextPath", "express"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("express", kwargs.hasOwnProperty("express") ? kwargs["express"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_21 = "";t_21 += "\n    ";
t_21 += runtime.suppressValue(((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"pwaCartIsEnabled")?(lineno = 89, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core")])) + "" + "cart":((lineno = 89, colno = 73, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "checkout/" + "" + ((runtime.contextOrFrameLookup(context, frame, "express")?"express":""))))), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_21);
});
context.addExport("checkoutUrl");
context.setVariable("checkoutUrl", macro_t_20);
var macro_t_22 = runtime.makeMacro(
[], 
["core", "absoluteURL", "excludeContextPath"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_23 = "";t_23 += runtime.suppressValue(((lineno = 100, colno = 86, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "account/account-settings"), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_23);
});
context.addExport("profileUrl");
context.setVariable("profileUrl", macro_t_22);
var macro_t_24 = runtime.makeMacro(
[], 
["core", "absoluteURL", "excludeContextPath"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_25 = "";t_25 += runtime.suppressValue(((lineno = 110, colno = 86, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "account/address"), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_25);
});
context.addExport("addressUrl");
context.setVariable("addressUrl", macro_t_24);
var macro_t_26 = runtime.makeMacro(
[], 
["core", "absoluteURL", "excludeContextPath"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_27 = "";t_27 += runtime.suppressValue(((lineno = 120, colno = 87, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "registry/home"), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_27);
});
context.addExport("registryUrl");
context.setVariable("registryUrl", macro_t_26);
var macro_t_28 = runtime.makeMacro(
["slug"], 
["core", "absoluteURL", "excludeContextPath"], 
function (l_slug, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slug", l_slug);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_29 = "";t_29 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, ((lineno = 132, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "help/" + "" + l_slug)), env.opts.autoescape);
if((lineno = 133, colno = 12, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.webview"]))) {
t_29 += "?webview=true";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_29);
});
context.addExport("helpUrl");
context.setVariable("helpUrl", macro_t_28);
var macro_t_30 = runtime.makeMacro(
[], 
["slug", "core", "absoluteURL", "excludeContextPath"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slug", kwargs.hasOwnProperty("slug") ? kwargs["slug"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_31 = "";t_31 += runtime.suppressValue((lineno = 146, colno = 94, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "stores", env.opts.autoescape);
if(runtime.contextOrFrameLookup(context, frame, "slug")) {
t_31 += runtime.suppressValue("/" + "" + runtime.contextOrFrameLookup(context, frame, "slug"), env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_31);
});
context.addExport("storeUrl");
context.setVariable("storeUrl", macro_t_30);
var macro_t_32 = runtime.makeMacro(
[], 
["core", "absoluteURL", "excludeContextPath", "dateRangeValue", "next", "prev"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("dateRangeValue", kwargs.hasOwnProperty("dateRangeValue") ? kwargs["dateRangeValue"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("next", kwargs.hasOwnProperty("next") ? kwargs["next"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("prev", kwargs.hasOwnProperty("prev") ? kwargs["prev"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_33 = "";var t_34;
t_34 = [];
frame.set("queryStringList", t_34, true);
if(frame.topLevel) {
context.setVariable("queryStringList", t_34);
}
if(frame.topLevel) {
context.addExport("queryStringList", t_34);
}
var t_35;
t_35 = (runtime.contextOrFrameLookup(context, frame, "dateRangeValue")?(lineno = 158, colno = 44, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "queryStringList")),"append"), "queryStringList[\"append\"]", context, ["dateRangeValue=" + "" + runtime.contextOrFrameLookup(context, frame, "dateRangeValue")])):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("dateRangeQuery", t_35, true);
if(frame.topLevel) {
context.setVariable("dateRangeQuery", t_35);
}
if(frame.topLevel) {
context.addExport("dateRangeQuery", t_35);
}
var t_36;
t_36 = (runtime.contextOrFrameLookup(context, frame, "next")?(lineno = 159, colno = 39, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "queryStringList")),"append"), "queryStringList[\"append\"]", context, ["next=" + "" + runtime.contextOrFrameLookup(context, frame, "next")])):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("nextQuery", t_36, true);
if(frame.topLevel) {
context.setVariable("nextQuery", t_36);
}
if(frame.topLevel) {
context.addExport("nextQuery", t_36);
}
var t_37;
t_37 = (runtime.contextOrFrameLookup(context, frame, "prev")?(lineno = 160, colno = 39, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "queryStringList")),"append"), "queryStringList[\"append\"]", context, ["prev=" + "" + runtime.contextOrFrameLookup(context, frame, "prev")])):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("prevQuery", t_37, true);
if(frame.topLevel) {
context.setVariable("prevQuery", t_37);
}
if(frame.topLevel) {
context.addExport("prevQuery", t_37);
}
t_33 += runtime.suppressValue((lineno = 161, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])), env.opts.autoescape);
t_33 += "orders?";
t_33 += runtime.suppressValue(env.getFilter("join").call(context, runtime.contextOrFrameLookup(context, frame, "queryStringList"),"&"), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_33);
});
context.addExport("ordersUrl");
context.setVariable("ordersUrl", macro_t_32);
var macro_t_38 = runtime.makeMacro(
["orderId"], 
["core", "absoluteURL", "excludeContextPath", "dateRangeValue", "next", "prev"], 
function (l_orderId, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("orderId", l_orderId);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("dateRangeValue", kwargs.hasOwnProperty("dateRangeValue") ? kwargs["dateRangeValue"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("next", kwargs.hasOwnProperty("next") ? kwargs["next"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("prev", kwargs.hasOwnProperty("prev") ? kwargs["prev"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_39 = "";var t_40;
t_40 = [];
frame.set("queryStringList", t_40, true);
if(frame.topLevel) {
context.setVariable("queryStringList", t_40);
}
if(frame.topLevel) {
context.addExport("queryStringList", t_40);
}
var t_41;
t_41 = (runtime.contextOrFrameLookup(context, frame, "dateRangeValue")?(lineno = 175, colno = 44, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "queryStringList")),"append"), "queryStringList[\"append\"]", context, ["dateRangeValue=" + "" + runtime.contextOrFrameLookup(context, frame, "dateRangeValue")])):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("dateRangeQuery", t_41, true);
if(frame.topLevel) {
context.setVariable("dateRangeQuery", t_41);
}
if(frame.topLevel) {
context.addExport("dateRangeQuery", t_41);
}
var t_42;
t_42 = (runtime.contextOrFrameLookup(context, frame, "next")?(lineno = 176, colno = 39, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "queryStringList")),"append"), "queryStringList[\"append\"]", context, ["next=" + "" + runtime.contextOrFrameLookup(context, frame, "next")])):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("nextQuery", t_42, true);
if(frame.topLevel) {
context.setVariable("nextQuery", t_42);
}
if(frame.topLevel) {
context.addExport("nextQuery", t_42);
}
var t_43;
t_43 = (runtime.contextOrFrameLookup(context, frame, "prev")?(lineno = 177, colno = 39, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "queryStringList")),"append"), "queryStringList[\"append\"]", context, ["prev=" + "" + runtime.contextOrFrameLookup(context, frame, "prev")])):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("prevQuery", t_43, true);
if(frame.topLevel) {
context.setVariable("prevQuery", t_43);
}
if(frame.topLevel) {
context.addExport("prevQuery", t_43);
}
t_39 += runtime.suppressValue((lineno = 178, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])), env.opts.autoescape);
t_39 += "order/";
t_39 += runtime.suppressValue(l_orderId, env.opts.autoescape);
t_39 += "?";
t_39 += runtime.suppressValue(env.getFilter("join").call(context, runtime.contextOrFrameLookup(context, frame, "queryStringList"),"&"), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_39);
});
context.addExport("orderUrl");
context.setVariable("orderUrl", macro_t_38);
var macro_t_44 = runtime.makeMacro(
["wishlistId"], 
["core", "absoluteURL", "excludeContextPath"], 
function (l_wishlistId, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("wishlistId", l_wishlistId);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_45 = "";t_45 += runtime.suppressValue((lineno = 189, colno = 98, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])), env.opts.autoescape);
t_45 += "wishlist";
if(l_wishlistId) {
t_45 += "/";
t_45 += runtime.suppressValue(l_wishlistId, env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_45);
});
context.addExport("wishlistUrl");
context.setVariable("wishlistUrl", macro_t_44);
var macro_t_46 = runtime.makeMacro(
[], 
["core", "absoluteURL", "excludeContextPath"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_47 = "";t_47 += runtime.suppressValue((lineno = 199, colno = 81, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])), env.opts.autoescape);
t_47 += "hearted-pics";
;
frame = frame.pop();
return new runtime.SafeString(t_47);
});
context.addExport("ugcUrl");
context.setVariable("ugcUrl", macro_t_46);
var macro_t_48 = runtime.makeMacro(
[], 
["core", "absoluteURL", "excludeContextPath"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_49 = "";t_49 += runtime.suppressValue((lineno = 210, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])), env.opts.autoescape);
t_49 += "hearted-products";
;
frame = frame.pop();
return new runtime.SafeString(t_49);
});
context.addExport("favoritesUrl");
context.setVariable("favoritesUrl", macro_t_48);
var macro_t_50 = runtime.makeMacro(
["slug", "queryParams"], 
["core", "absoluteURL", "excludeContextPath"], 
function (l_slug, l_queryParams, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slug", l_slug);
frame.set("queryParams", l_queryParams);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_51 = "";var t_52;
t_52 = env.getFilter("lower").call(context, env.getFilter("replace").call(context, l_slug," ","-"));
frame.set("sanitizedSlug", t_52, true);
if(frame.topLevel) {
context.setVariable("sanitizedSlug", t_52);
}
if(frame.topLevel) {
context.addExport("sanitizedSlug", t_52);
}
t_51 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, ((lineno = 223, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "brands/" + "" + runtime.contextOrFrameLookup(context, frame, "sanitizedSlug"))), env.opts.autoescape);
if(l_queryParams) {
t_51 += "?";
t_51 += runtime.suppressValue(l_queryParams, env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_51);
});
context.addExport("brandsUrl");
context.setVariable("brandsUrl", macro_t_50);
var macro_t_53 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_54 = "";t_54 += runtime.suppressValue(env.getFilter("trim").call(context, (lineno = 236, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "getScene7ImagePath"), "getScene7ImagePath", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"thirdParty"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteId")]))), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_54);
});
context.addExport("imageUrl");
context.setVariable("imageUrl", macro_t_53);
var macro_t_55 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_56 = "";t_56 += runtime.suppressValue(env.getFilter("trim").call(context, (lineno = 248, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "getScene7VideoPath"), "getScene7VideoPath", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"thirdParty"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteId")]))), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_56);
});
context.addExport("videoUrl");
context.setVariable("videoUrl", macro_t_55);
var macro_t_57 = runtime.makeMacro(
["queryParams"], 
["core", "absoluteURL", "excludeContextPath"], 
function (l_queryParams, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("queryParams", l_queryParams);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_58 = "";t_58 += runtime.suppressValue((lineno = 259, colno = 97, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])), env.opts.autoescape);
t_58 += "search";
if(l_queryParams) {
t_58 += "?";
t_58 += runtime.suppressValue(l_queryParams, env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_58);
});
context.addExport("searchUrl");
context.setVariable("searchUrl", macro_t_57);
var macro_t_59 = runtime.makeMacro(
[], 
["core", "absoluteURL", "excludeContextPath"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_60 = "";t_60 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, ((lineno = 261, colno = 85, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "/user/create")), env.opts.autoescape);
if(runtime.contextOrFrameLookup(context, frame, "originalURL")) {
t_60 += "?url=";
t_60 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "originalURL"), env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_60);
});
context.addExport("signUpUrl");
context.setVariable("signUpUrl", macro_t_59);
var macro_t_61 = runtime.makeMacro(
[], 
["core", "absoluteURL", "excludeContextPath"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_62 = "";t_62 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, ((lineno = 263, colno = 84, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "/login")), env.opts.autoescape);
if(runtime.contextOrFrameLookup(context, frame, "originalURL")) {
t_62 += "?url=";
t_62 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "originalURL"), env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_62);
});
context.addExport("loginUrl");
context.setVariable("loginUrl", macro_t_61);
var macro_t_63 = runtime.makeMacro(
[], 
["core", "absoluteURL", "excludeContextPath"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_64 = "";t_64 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, ((lineno = 265, colno = 93, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL"),runtime.contextOrFrameLookup(context, frame, "excludeContextPath")])) + "" + "/user/password/forgot")), env.opts.autoescape);
if(runtime.contextOrFrameLookup(context, frame, "originalURL")) {
t_64 += "?url=";
t_64 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "originalURL"), env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_64);
});
context.addExport("forgotPasswordUrl");
context.setVariable("forgotPasswordUrl", macro_t_63);
var macro_t_65 = runtime.makeMacro(
[], 
["url"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("url", kwargs.hasOwnProperty("url") ? kwargs["url"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_66 = "";if(runtime.contextOrFrameLookup(context, frame, "url")) {
if(env.getFilter("startswith").call(context, runtime.contextOrFrameLookup(context, frame, "url"),["http:","sms:","https:","www.","//"])) {
t_66 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "url"), env.opts.autoescape);
;
}
else {
if(env.getFilter("startswith").call(context, runtime.contextOrFrameLookup(context, frame, "url"),"/")) {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"contextPath") != "/" && !(env.getFilter("startswith").call(context, runtime.contextOrFrameLookup(context, frame, "url"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"contextPath")))) {
t_66 += runtime.suppressValue((lineno = 283, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core")])), env.opts.autoescape);
t_66 += runtime.suppressValue(env.getFilter("replace").call(context, runtime.contextOrFrameLookup(context, frame, "url"),"/","",1), env.opts.autoescape);
;
}
else {
t_66 += runtime.suppressValue((lineno = 285, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core")])), env.opts.autoescape);
t_66 += runtime.suppressValue(env.getFilter("replace").call(context, runtime.contextOrFrameLookup(context, frame, "url"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"contextPath"),"",1), env.opts.autoescape);
;
}
;
}
else {
t_66 += runtime.suppressValue((lineno = 288, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "contextUrl"), "contextUrl", context, [runtime.contextOrFrameLookup(context, frame, "core")])), env.opts.autoescape);
t_66 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "url"), env.opts.autoescape);
;
}
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_66);
});
context.addExport("contentfulUrl");
context.setVariable("contentfulUrl", macro_t_65);
var macro_t_67 = runtime.makeMacro(
["slug", "queryParams"], 
["core", "absoluteURL", "excludeContextPath"], 
function (l_slug, l_queryParams, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slug", l_slug);
frame.set("queryParams", l_queryParams);
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("absoluteURL", kwargs.hasOwnProperty("absoluteURL") ? kwargs["absoluteURL"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("excludeContextPath", kwargs.hasOwnProperty("excludeContextPath") ? kwargs["excludeContextPath"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_68 = "";t_68 += runtime.suppressValue((lineno = 293, colno = 100, runtime.callWrap(macro_t_11, "productUrl", context, [l_slug,l_queryParams,runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core"),"absoluteURL": runtime.contextOrFrameLookup(context, frame, "absoluteURL"),"excludeContextPath": runtime.contextOrFrameLookup(context, frame, "excludeContextPath")})])), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_68);
});
context.addExport("mtoUrl");
context.setVariable("mtoUrl", macro_t_67);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/urls.j2"] , dependencies)